import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

/**
 * Bronson FormSectionGroup component.
 * @see https://bronson.vwfs.tools/default/components/detail/bronson-form-section-group.html
 *
 * @param {FormSection|FormSection[]} [children] - Collection of {@link FormSection} items.
 * @param {string} [className] - Optional class name on the main element.
 * @param {string} [testId] - The `[data-testid]` attribute on the component element.
 * @param {object} [otherProps] - Other props passed to the component element.
 * @returns {JSX.Element} - The FormSectionGroup component.
 * @constructor
 */
export function FormSectionGroup({ children, className, testId, ...otherProps }) {
  const divClassNameList = classNames('c-form-section-group', className).trim()

  return (
    <div {...otherProps} data-testid={testId} className={divClassNameList}>
      {children}
    </div>
  )
}

FormSectionGroup.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.node, PropTypes.array]), // Bronson template: 'form-sections'. Use {@link FormSection} component.
  className: PropTypes.string,
  testId: PropTypes.string, // Added for `[data-testid]` attribute.
}
